import React from 'react';
import BagIconMedium from './BagIconMedium';
import BagIconSmall from './BagIconSmall';
const BagIcon = ({ size = 'medium', ...props }) => size === 'medium' ? React.createElement(BagIconMedium, { ...props }) : React.createElement(BagIconSmall, { ...props });
export default BagIcon;
//# sourceMappingURL=BagIcon.js.map